import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "libre_basker text-white" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" ©2022 Nolan Sparkle & Shine. All rights reserved.")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    position: "bottom",
    elevation: "10",
    class: "footer"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar_title, null, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.getAddress ? `Registered Office: ${_ctx.getAddress}` : "") + " " + _toDisplayString(_ctx.getBusinessRegistrationNumber ? ` Business Number: ${_ctx.getBusinessRegistrationNumber}` : ""), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}